// The one shared AI-model registry used by every image scanner (food
// label, meal photo, equipment, workout plan, recipe, and any added
// later). See design-docs/scanner-model-config.md.
//
// Before #3783 each scanner had its own registry (LABEL_SCAN_MODELS had 7
// models; equipment and workout had 3 each), and the server validated the
// requested model against the per-scanner registry — so a model valid for
// one scanner came back as UnknownModel for another. SCAN_MODELS is the
// union of those three registries, used by every scanner on both client
// and server, so any configured model is valid everywhere.

export interface ScanModel {
  key: string;
  provider: 'gemini' | 'openai' | 'claude';
  modelId: string;
  displayName: string;
  costPer1000: number; // estimated cost per 1000 scans in USD
}

/** Default model when a scanner has no provider config at all. */
export const DEFAULT_SCAN_MODEL_KEY = 'gemini-2.5-flash';

/** The union of the three former per-scanner registries (ordered roughly by
 *  cost). `gpt-4o` came only from the equipment/workout registries; every
 *  other entry came from the label registry. */
export const SCAN_MODELS: ScanModel[] = [
  { key: 'gemini-2.5-flash', provider: 'gemini', modelId: 'gemini-2.5-flash',          displayName: 'Gemini 2.5 Flash',  costPer1000: 3 },
  { key: 'gpt-4.1-mini',     provider: 'openai', modelId: 'gpt-4.1-mini',              displayName: 'GPT-4.1 Mini',      costPer1000: 3 },
  { key: 'claude-haiku-4.5', provider: 'claude', modelId: 'claude-haiku-4-5-20251001', displayName: 'Claude Haiku 4.5',  costPer1000: 5 },
  { key: 'gpt-4o-mini',      provider: 'openai', modelId: 'gpt-4o-mini',              displayName: 'GPT-4o Mini',       costPer1000: 5 },
  { key: 'gemini-2.5-pro',   provider: 'gemini', modelId: 'gemini-2.5-pro',            displayName: 'Gemini 2.5 Pro',    costPer1000: 6 },
  { key: 'gpt-4.1',          provider: 'openai', modelId: 'gpt-4.1',                   displayName: 'GPT-4.1',           costPer1000: 9 },
  { key: 'gpt-4o',           provider: 'openai', modelId: 'gpt-4o',                   displayName: 'GPT-4o',            costPer1000: 12 },
  { key: 'claude-sonnet-4.6',provider: 'claude', modelId: 'claude-sonnet-4-6',         displayName: 'Claude Sonnet 4.6', costPer1000: 16 },
];
